import { isTimeSignature } from '../TimeSignature';
export function dynamicsValue(dynamics) {
    return dynamics == 'accent' ? 1 : dynamics == null ? 0.8 : 0.3;
}
export function isPatternHit(x) {
    return typeof x?.tick == 'number';
}
export function isPattern(x) {
    return isTimeSignature(x?.signature) &&
        typeof x?.measures == 'number' &&
        Array.isArray(x?.hits) && x.hits.every(isPatternHit);
}
//# sourceMappingURL=Pattern.js.map